import { MeetingPageField } from '../../types/plann3r'
import {
  MEETING_PAGE_UPDATE_IS_VIDEOCALL,
  MEETING_PAGE_UPDATE_DURATION,
  REQUEST_MEETING_PAGE_DETAILS,
  RECEIVE_MEETING_PAGE_DETAILS,
  MEETING_PAGE_UPDATE_VALUE,
  SET_MEETING_PAGE_RESPONSE_RECEIVED,
  MEETING_PAGE_SET_MOMENT_PICKING,
} from './actions'
import { MeetingPageStore, MeetingPageActionType } from './types'

const initialState: MeetingPageStore = {
  id: 0,
  duration: 0,
  response_received: false,
  moment_picking: false,
  isFetching: true,
  isVideoCall: false,
  auto_accept: false,
  display_name: '',
  logo: '',
  fields: [],
}

export const reducer = (
  state = initialState,
  action: MeetingPageActionType,
) : MeetingPageStore => {
  let fields
  switch (action.type) {
    case REQUEST_MEETING_PAGE_DETAILS:
      return {
        ...state,
        isFetching: true,
      }
    case RECEIVE_MEETING_PAGE_DETAILS:
      return {
        ...state,
        id: action.page.id,
        isFetching: false,
        fields: action.page.fields,
        logo: action.page.logo,
        display_name: action.page.display_name,
        locations: action.page.locations,
        colors: action.page.colors,
      }
    
    case SET_MEETING_PAGE_RESPONSE_RECEIVED:
      return {
        ...state,
        response_received: true,
      }

    case MEETING_PAGE_UPDATE_VALUE:
      fields = state.fields.map((field: MeetingPageField) => {
        if (field.id === action.id) {
          field.value = action.value
        }
        return field
      })
      return {
        ...state,
        fields,
      }

    case MEETING_PAGE_UPDATE_IS_VIDEOCALL:
      return {
        ...state,
        isVideoCall: action.isVideoCall,
      }

    case MEETING_PAGE_UPDATE_DURATION:
      return {
        ...state,
        duration: action.duration,
      }
    
    case MEETING_PAGE_SET_MOMENT_PICKING:
      return {
        ...state,
        moment_picking: action.pick_moment,
      }

    default:
      return state
  }
}
